<template>
  <div class="component">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <h5
                    class="card-title mt-1"
                  >{{!user.id ? 'Novo' : (edit_permission ? 'Editar' : 'Visualizar')}} {{user.id ? (logged_id == user.id ? 'meu perfil' : 'Usuário') : 'Usuário'}}</h5>
                </div>
              </div>
              <hr />

              <div class="form-group" v-if="photo">
                <div class="card-photo text-center">
                  <img
                    :src="photo.url"
                    style="width: 20%; margin-left:auto; margin-right:auto; height: auto; margin-top: 20px;"
                    class="image"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="name">
                  Foto:
                  <span v-if="required('photo_id')">*</span>
                </label>
                <b-form-file
                  v-model="user.photo_id"
                  placeholder="Escolha um arquivo"
                  drop-placeholder="Arraste o arquivo aqui..."
                  browse-text="Procurar"
                  accept="image/jpeg, image/png, image/jpg"
                  v-bind:class="{'input-error': showError('photo_id')}"
                  v-on:change="uploadImage"
                  :disabled="!edit_permission"
                ></b-form-file>
              </div>

              <div class="form-group">
                <label for="name">
                  Nome
                  <span v-if="required('name')">*</span>
                </label>
                <input
                  name="name"
                  v-model="user.name"
                  type="text"
                  class="form-control"
                  v-bind:class="{'input-error': showError('name')}"
                  :disabled="!edit_permission"
                />
                <div class="general-error" v-if="showError('name')">O campo Nome é necessário</div>
              </div>

              <div class="form-group">
                <label for="name">
                  E-mail
                  <span v-if="required('email')">*</span>
                </label>
                <input
                  name="email"
                  v-model="user.email"
                  type="email"
                  class="form-control"
                  v-bind:class="{'input-error': showError('email')}"
                  :disabled="!edit_permission"
                  autocomplete="new-email"
                />
                <div class="general-error" v-if="showError('email')">O campo E-mail é necessário</div>
              </div>

              <div v-if="!user.id" class="form-group">
                <label for="name">
                  Senha
                  <span v-if="required('email')">*</span>
                </label>
                <div class="input-group">
                  <input
                    name="password"
                    v-model="user.password"
                    :type="value_password"
                    class="form-control"
                    v-bind:class="{'input-error': showError('email')}"
                    :disabled="!edit_permission"
                    autocomplete="new-password"
                  />

                  <span class="input-group-text" v-on:click="show_password()">
                    <font-awesome-icon icon="eye" />
                  </span>
                  <!-- <div class="general-error" v-if="showError('email')">O campo Senha é necessário</div> -->
                </div>
              </div>

              <div class="form-group">
                <label for="name">
                  Nível de Acesso
                  <span v-if="required('role')">*</span>
                </label>
                <select
                  class="form-control"
                  id="exampleFormControlSelect1"
                  v-model="user.role"
                  v-bind:class="{'input-error': showError('role')}"
                  :disabled="!edit_permission"
                >
                  <option value="admin">Administrador</option>
                  <option value="employee">Funcionário</option>
                  <option value="externalEmployee">Funcionário Externo</option>
                  <option value="client">Cliente</option>
                </select>
                <div class="general-error" v-if="showError('role')">O campo Nível de Acesso é necessário</div>
              </div>

              <div class="form-group">
                <label for="name">CREA</label>
                <input
                  name="name"
                  v-model="user.crea"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength = "25"
                  type="text"
                  class="form-control"
                  :disabled="!edit_permission"
                />
                <!-- <div class="general-error" v-if="showError('crea')">O campo CREA é necessário</div> -->
              </div>

              <div class="form-group">
                <label for="name">
                  Cargo
                  <span v-if="required('degree')">*</span>
                </label>
                <input
                  name="name"
                  v-model="user.degree"
                  type="text"
                  class="form-control"
                  v-bind:class="{'input-error': showError('degree')}"
                  :disabled="!edit_permission"
                />
                <div class="general-error" v-if="showError('degree')">O campo Cargo é necessário</div>
              </div>

              <div class="form-group" v-if="show_companies && user.role=='employee'">
                <label for="name">
                  Função
                  <span v-if="required('user_function')">*</span>
                </label>
                <select
                  class="form-control"
                  id="exampleFormControlSelect1"
                  v-model="user_function"
                  v-bind:class="{'input-error': showError('user_function')}"
                  :disabled="!edit_permission"
                >
                  <option value="técnico" selected>Técnico</option>
                  <option value="engenheiro">Engenheiro</option>
                </select>
                <div class="general-error" v-if="showError('user_function')">O campo Função é necessário</div>
              </div>

              <div class="form-group" v-if="show_companies && (user.role == 'client' || user.role == 'externalEmployee')">
                <label>
                  Unidade
                  <span v-if="required('selected_companies')">*</span>
                </label>
                <multiselect
                  v-model="selected_companies"
                  :multiple="true"
                  :options="companies"
                  track-by="id"
                  label="corporate_name"
                  v-bind:class="{'input-error': showError('selected_companies')}"
                  :disabled="!edit_permission"
                  placeholder="Selecione unidades"
                ></multiselect>
                <div
                  class="general-error"
                  v-if="showError('selected_companies')"
                >O campo Unidade é necessário</div>
              </div>

              <div class="row" v-if="edit_permission">
                <div class="col-6"></div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-success float-right"
                    v-on:click="save()"
                  ><span>Salvar <font-awesome-icon icon="save" /> </span></button>
                </div>
              </div>

              <b-alert
                v-show="success"
                variant="success"
                show
              >Usuário {{!user.id ? 'Criado' : 'Salvo'}}</b-alert>
              <b-alert v-show="warning" variant="warning" show>Ocorreu um erro</b-alert>
              <b-alert v-show="warning" variant="danger" v-for="(error, index) in errors" :key="index" show>{{ error[0] }}</b-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Address from "@/components/AddressFields.vue";
import axios from "@/api/axios";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";

export default {
  name: "NewUser",
  components: {
    Multiselect
  },
  props: {
    id: String
  },
  data() {
    return {
      value_password: "password",
      address: {},
      companies: [],
      selected_companies: [],
      show_companies: false,
      user_function: "técnico",
      machine: {},
      group: {},
      submited: false,
      user: {},
      success: false,
      warning: false,
      errors: [],
      photo: null,
      tempImage: "",
      role: localStorage.getItem("auth.role"),
      logged_id: localStorage.getItem("auth.user_id"),
      edit_permission: this.role == "admin" || !this.id,
      items: []
    };
  },
  mounted() {
    this.edit_permission = this.role == "admin" || !this.id;

    if (this.id && !this.edit_permission) {
      this.items = [
        {
          text: "Visualizar",
          active: true
        }
      ];
    } else {
      this.items = [
        {
          text: "Usuários",
          href: "#/admin/Users/ListUsers"
        },
        {
          text: !this.id
            ? "Novo"
            : "Editar",
          active: true
        }
      ];
    }

    if (this.id) {
      this.getUser();
    }
    this.getCompanies();
    this.getUserType();
  },
  validations: {
    selected_companies: {},
    user: {
      photo_id: {},
      name: {
        required
      },
      email: {
        required
      },
      password: {},
      degree: {},
      role: {
        required
      },
      user_function: {
      }
    }
  },
  methods: {
    show_password: function() {
      this.value_password =
        this.value_password == "password" ? "text" : "password";
    },

    save: function() {
      this.submited = true;
      this.errors = [];
      this.warning = false;

      if (!this.$v.$invalid) {
        if (!this.user.id) {
          axios
            .post(`${process.env.VUE_APP_API_HOST}/api/admin/users`, {
              name: this.user.name,
              email: this.user.email,
              password: this.user.password,
              degree: this.user.degree,
              crea: this.user.crea,
              role: this.user.role,
              companies: this.selected_companies,
              image: this.tempImage,
              user_function: this.user_function
            })
            .then(response => {
              this.success = true;
              setTimeout(() => {
                this.success = false;
                this.$router.push("ListUsers");
              }, 1500);
              return response.data;
            })
            .catch(error => {
              const response = error.response
              this.errors = response.data.errors;
              this.warning = true;
            });
        } else {
          this.edit();
        }
      }
    },

    showError: function(attribute) {
      if (attribute == "selected_companies")
        return this.$v.selected_companies.$invalid && this.submited;
      return this.$v.user[attribute].$invalid && this.submited;
    },
    required: function(attribute) {
      if (attribute == "selected_companies")
        return this.$v.selected_companies.$invalid && this.submited;
      return this.$v.user[attribute].$params.required;
    },
    edit: function() {
      let companies_id = [];
      for (var i = 0; i < this.selected_companies.length; i++) {
        companies_id.push(this.selected_companies[i].id);
      }
      this.errors = [];
      this.warning = false;

      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/users/` + this.user.id,
          {
            id: this.user.id,
            name: this.user.name,
            email: this.user.email,
            password: this.user.password,
            degree: this.user.degree,
            crea: this.user.crea,
            role: this.user.role,
            image: this.tempImage,
            companies: companies_id,
            user_function: this.user_function
          }
        )
        .then(response => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
            this.$router.push("ListUsers");
          }, 1500);
          return response.data;
        })
        .catch(error => {
          const response = error.response
          this.errors = response.data.errors;
          this.warning = true;
        });
    },
    getUserType: function() {
      if (this.role == "client" || this.role == "employee") {
        if (this.id == undefined) {
          this.$router.push("/admin/Home");
        }
      }
    },
    getUser: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/users/` + this.id)
        .then(response => {
          this.user = response.data.data;
          this.selected_companies = this.user.companies;
          this.photo = this.user.photo;
          this.user_function = this.user.companies[0].pivot.function || "";
        });
    },
    getCompanies: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/companies`, {
          params: {
            not_paginated: true,
            user_email: this.email,
            user_role: this.role,
            reduced: true,
          },
        })
        .then(response => {
          this.companies = response.data.data;
          this.$nextTick(() => {
            this.show_companies = true;
          });
        });
    },
    uploadImage: function(e) {
      const file = e.target.files[0];

      if (!file.type.includes("image/")) {
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = event => {
          this.tempImage = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../../styles/CorporateGroupCreate.scss";
@import "src/styles/General.scss";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
